<template>
  <div :class="[$style.header, { [$style.userHeader]: isUser }]">
    <div :class="$style.header_content">
      <div :class="$style.header_left">
        <img
          :class="$style.logo"
          :src="logoImg"
          alt="logo"
          @click="() => jumpPage('/', true)"
        />
      </div>

      <div v-if="showCenter" :class="$style.header_center">
        <template v-for="(option, index) in options">
          <div
            :key="index"
            :class="{
              [$style.item]: true,
              [$style.active]: option.link === currentPath,
            }"
            @click="() => jumpPage(option.link, option.isRouter)"
          >
            {{ option.name }}
          </div>
        </template>
      </div>

      <div :class="$style.header_right">

        <template v-if="!isLogin">
          <router-link :class="$style.whois" to="/whoisSearch"
          >Whois查询</router-link>
          <router-link :class="$style.mail_box" to="/user/mail">
            <img :class="$style.mail_img" :src="mailImg" alt="">
          </router-link>
          <div :class="[$style.btn, $style.btn_login]" @click="toLogin">
            登录
          </div>
          <div :class="[$style.btn, $style.btn_register]" @click="toRegister">
            免费注册
          </div>
        </template>

        <template v-else>
          <router-link :class="$style.whois" to="/whoisSearch"
          >Whois查询</router-link>
          <router-link :class="$style.mail_box" to="/user/mail">
            <img :class="$style.mail_img" :src="mailImg" alt="">
            <div v-if='userInfo.siteCount > 0' :class="$style.mail_num">{{ userInfo.siteCount > 99 ? '99+' : userInfo.siteCount  }}</div>
          </router-link>
          <el-dropdown trigger="hover" placement="bottom-end">
            <div :class="$style.logged" @click="toUserCenter">
              <img :class="$style.logged_img" :src="loggedImg" alt="person" />
              <span :class="$style.user">
                {{ userInfo.nickname || userInfo.id }}
              </span>
              <i class="el-icon-caret-bottom"></i>
            </div>

            <el-dropdown-menu slot="dropdown" :class="$style.header_drop">
              <div :class="$style.card">
                <div :class="$style.card_top">
                  <div :class="$style.user_account">
                    {{ userInfo.nickname || userInfo.id }}
                  </div>
                  <div :class="$style.user_id">账号ID：{{ userInfo.id }}</div>
                </div>
                <div v-show="!isUser" :class="$style.card_center">
                  <template v-for="option in user_options">
                    <div
                      :key="option.id"
                      :class="$style.user_option"
                      @click="() => jumpPage(option.link, true)"
                    >
                      · {{ option.name }}
                    </div>
                  </template>
                </div>

                <Button
                  :class="$style.login_out"
                  type="primary"
                  @click="handleLoginOut"
                >
                  退出登录
                </Button>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "Header",
  props: {
    showCenter: {
      type: Boolean,
      default: true,
    },
    isUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPath: "/",
      options: [
        {
          name: "首页",
          link: "http://nsdt.com",
        },
        {
          name: "域名注册",
          link: "/",
          isRouter: true,
        },
        {
          name: "关于我们",
          link: "http://nsdt.com/gywm",
        },
        {
          name: "投诉及建议",
          link: "http://nsdt.com/lxwm",
        },
        {
          name: "我的账户",
          link: "/user",
          isRouter: true,
        },
      ],
      user_options: [
        {
          id: 1,
          name: "域名管理",
          link: "/user/my-domain",
        },
        {
          id: 2,
          name: "账户信息",
          link: "/user/account",
        },
        {
          id: 3,
          name: "个人资料",
          link: "/user/detail",
        },
        {
          id: 4,
          name: "安全中心",
          link: "/user/safe",
        },
        {
          id: 5,
          name: "我的认证",
          link: "/user/certification",
        },
      ],
    };
  },
  computed: {
    ...mapState("login", ["isLogin"]),
    ...mapState("user", ["userInfo"]),
    logoImg() {
      return require(`@assets/image/${
        this.isUser ? "logo_white" : "logo"
      }.png`);
    },
    loggedImg() {
      return require(`@assets/image/${
        this.isUser ? "person_white" : "person"
      }.png`);
    },
    mailImg(){
       return require(`@assets/image/${
        this.isUser ? "mail" : "mail-r"
      }.png`);
    },
  },
  methods: {
    ...mapMutations("login", ["loginOut"]),
    ...mapActions("user", ["getMemberInfoAction", "getAmountInfoAction"]),

    jumpPage(link, isRouter) {
      if (isRouter) {
        this.$router.push(link);
      } else {
        window.open(link, "_blank");
      }
    },
    toLogin() {
      this.$router.push("/login");
    },
    toRegister() {
      this.$router.push("/register");
    },

    handleLoginOut() {
      this.loginOut();
      this.$message({ message: "成功退出登录", type: "success" });
      const path = this.$route.path;
      path !== "/" && this.$router.push("/");
    },

    toUserCenter() {
      this.$router.push("/user");
    },

    setCurrentPath() {
      const path = this.$route.path;

      // 对于嵌套路由路径，映射 this.data.options.link
      const mapPath = {
        "/": "/",
        "/dRegister": "/",
        "/dSearch": "/",
        "/dPrice": "/",
      };

      if (/^\/user/.test(path)) {
        this.currentPath = "/user";
        return;
      }

      this.currentPath = mapPath[path] || path;
    },
  },

  created() {
    this.setCurrentPath();

    if (this.isLogin) {
      this.getMemberInfoAction();
      this.getAmountInfoAction();
    }
  },
};
</script>

<style lang="scss" module scoped>
.header {
  width: 100%;
  background: #ffffff;

  .header_content {
    min-width: 1024px;
    height: rem(80);
    /* PC滚动条默认宽16px，header两端需用padding撑开，避免内容被遮挡 */
    padding: 0 16px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    box-shadow: 0 7px 32px 0 rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    z-index: 1999;
  }

  .header_left {
    width: rem(240);
    height: 100%;
    display: flex;
    align-items: center;

    .logo {
      margin-left: rem(44);
      width: rem(150);
      height: rem(53);
      object-fit: cover;
      cursor: pointer;
    }
  }

  .header_center {
    flex: 0 1 rem(1200);
    min-width: 540px;
    height: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    .item {
      padding: rem($padding-3n) rem($padding-4n);
      margin-right: rem($margin-3n);
      font-size: rem(14);
      color: #333;
      font-weight: $font-weight-light;
      border: 1px solid transparent;
      border-radius: 20px;
      background: #ffffff;
      cursor: pointer;
      transition: all 0.3s;

      &:first-child {
        margin-left: rem(-$padding-4n);
      }

      &:hover {
        color: $theme-color;
      }

      &.active {
        color: $theme-color;
        border-color: $theme-color;
      }
    }
  }

  .header_right {
    display: flex;
    justify-content: flex-end;
    flex-wrap: nowrap;
    position: relative;
    width: rem(400);

    .whois {
      color: #333;
      font-size: rem(14);
      line-height: rem(80);
      margin-right: 10px;
      cursor: pointer;
      text-decoration: none;
    }

    .mail_box{
      position: relative;
      width:rem(48);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: rem(5);
      .mail_img{
        width: rem(24);
        height: rem(24);
      }
      .mail_num{
        box-sizing: border-box;
        min-width: rem(18);
        padding:0 5px;
        height: rem(18);
        border-radius: rem(9);
        color: #fff;
        font-size: rem(12);
        background: #F9521f;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top:rem(16);
        right: -5px;
      }
    }

    .btn {
      width: rem(120);
      height: rem(80);
      font-size: rem(14);
      color: #666;
      line-height: rem(80);
      text-align: center;
      cursor: pointer;
    }

    .btn_login {
      &:hover {
        color: $theme-color;
      }
    }

    .btn_register {
      color: #fff;
      background: $theme-color;
      &:hover {
        background: $theme-hover-color;
      }
    }

    .logged {
      @include flex();
      width: 100%;
      min-width: 60px;
      height: rem(80);
      margin-right: 20px;
      font-size: rem(14);
      color: #333;
      cursor: pointer;

      .logged_img {
        width: 20px;
      }

      .user {
        margin-left: 10px;
        margin-right: 8px;
      }
    }
  }

  &.userHeader {
    background: #2b303b;

    .header_content {
      background: #2b303b;
    }

    .header_center .item {
      color: $white;
      border: 1px solid transparent;
      background: #2b303b;
      &.active {
        border-color: $white;
      }
    }
    .whois{
      color: #fff;
    }
    .header_right .logged {
      color: #fff;
    }
  }
}

.header_drop {
  margin: 0;
  border: none;
  border-radius: 0;

  :global {
    ::v-deep .popper__arrow {
      display: none;
    }
  }
}

.card {
  box-sizing: border-box;
  width: 220px;
  height: auto;
  background: $white;
  transition: all 0.3s;

  .card_top {
    padding: rem(20);
    margin: 0 rem(20);
    border-bottom: $border-1;

    .user_account {
      font-size: max(rem(18), 16px);
      font-weight: bold;
      line-height: 32px;
    }

    .user_id {
      font-size: rem(14);
      line-height: 28px;
    }
  }

  .card_center {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 8px rem(40);

    .user_option {
      width: 50%;
      font-size: rem(14);
      color: #333333;
      line-height: 28px;
      cursor: pointer;

      &:hover {
        color: $theme-color;
      }
    }
  }

  .login_out {
    margin: rem(20) rem(40) rem(30);
    border-radius: rem(4);
  }
}
</style>
